export default __webpack_public_path__ + "static/media/Logo-not-name.b2f90e9a.svg";